import {
  Checkbox,
  IconButton,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import CardTitle from "@saleor/components/CardTitle";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import {
  SortableTableBody,
  SortableTableRow
} from "@saleor/components/SortableTable";
import { CountryDetailsFragment_regions } from "@saleor/fragments/types/CountryDetailsFragment";
import { maybe, renderCollection, stopPropagation } from "@saleor/misc";
import { ReorderAction } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface RegionsProps {
  disabled: boolean;
  regions: CountryDetailsFragment_regions[];
  onValueAdd: () => void;
  onValueDelete: (id: string) => void;
  onValueReorder: ReorderAction;
  onValueUpdate: (id: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    columnDrag: {
      width: 48 + theme.spacing(1.5)
    },
    columnText: {
      width: 250,
      overflow: "hidden", // 超出的文本隐藏
      textOverflow: "ellipsis", // 溢出用省略号显示
      whiteSpace: "nowrap" // 溢出不换行
    },
    dragIcon: {
      cursor: "grab"
    },
    iconCell: {
      "&:last-child": {
        paddingRight: theme.spacing()
      },
      width: 80
    },
    link: {
      cursor: "pointer"
    },
    def: {
      width: "auto"
    }
  }),
  { name: "RotaryItems" }
);

const Regions: React.FC<RegionsProps> = ({
  disabled,
  onValueAdd,
  onValueDelete,
  onValueReorder,
  onValueUpdate,
  regions
}) => {
  const classes = useStyles({});
  const intl = useIntl();
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage({
          defaultMessage: "Regions",
          description: "section header"
        })}
        toolbar={
          <Button color="primary" variant="text" onClick={onValueAdd}>
            <FormattedMessage
              defaultMessage="Assign Regions"
              description="assign Regions  button"
            />
          </Button>
        }
      />
      <ResponsiveTable>
        <TableHead>
          <TableRow>
            <TableCell className={classes.columnDrag} />
            <TableCell className={classes.columnText}>
              <FormattedMessage defaultMessage="Name" description="Name" />
            </TableCell>
            <TableCell className={classes.def}>
              <FormattedMessage defaultMessage="Code" description="Code" />
            </TableCell>
            <TableCell className={classes.def}>
              <FormattedMessage defaultMessage="Order" description="Code" />
            </TableCell>
            <TableCell className={classes.def}>
              <FormattedMessage defaultMessage="Enable" description="Enable" />
            </TableCell>
            <TableCell className={classes.iconCell} />
          </TableRow>
        </TableHead>
        <SortableTableBody onSortEnd={onValueReorder}>
          {renderCollection(
            regions,
            (region, itemIndex) => (
              <SortableTableRow
                hover={!!region}
                onClick={!!region ? () => onValueUpdate(region.id) : undefined}
                key={maybe(() => region.id)}
                index={itemIndex || 0}
              >
                <TableCell className={classes.columnText}>
                  {maybe(() => region.name) ? (
                    <p
                      className={classes.columnText}
                      style={{ width: "100%" }}
                      title={region.name}
                    >
                      {region.name}
                    </p>
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.def}>
                  {maybe(() => region.code) ? region.code : <Skeleton />}
                </TableCell>
                <TableCell className={classes.def}>
                  {maybe(() => region.displayOrder) ? (
                    region.displayOrder
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell className={classes.def}>
                  <Checkbox
                    name={"enable" as keyof CountryDetailsFragment_regions}
                    checked={region?.enable}
                  />
                  {/* {maybe(() => region?.enable) ?'YES':'NO' } */}
                </TableCell>
                <TableCell className={classes.iconCell}>
                  <IconButton
                    disabled={disabled}
                    onClick={stopPropagation(() => onValueDelete(region.id))}
                  >
                    <DeleteIcon color="primary" />
                  </IconButton>
                </TableCell>
              </SortableTableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={4}>
                  <FormattedMessage
                    defaultMessage="No Regions found"
                    description="No Regions found"
                  />
                </TableCell>
              </TableRow>
            )
          )}
        </SortableTableBody>
      </ResponsiveTable>
    </Card>
  );
};
export default Regions;
